import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Uvoziš prevode iz src foldera
import en from "./assets/lang/en.json";
import de from "./assets/lang/de.json";
import fr from "./assets/lang/fr.json";
import es from "./assets/lang/es.json";
import it from "./assets/lang/it.json";
import ru from "./assets/lang/ru.json";
import zh from "./assets/lang/zh.json";
import hu from "./assets/lang/hu.json";
import cs from "./assets/lang/cs.json";
import nl from "./assets/lang/nl.json";
import pl from "./assets/lang/pl.json";
import pt from "./assets/lang/pt.json";
import ro from "./assets/lang/ro.json";
import sr from "./assets/lang/sr.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    fr: { translation: fr },
    es: { translation: es },
    it: { translation: it },
    ru: { translation: ru },
    zh: { translation: zh },
    hu: { translation: hu },
    cs: { translation: cs },
    nl: { translation: nl },
    pl: { translation: pl },
    pt: { translation: pt },
    ro: { translation: ro },
    sr: { translation: sr },
  },
  lng: navigator.language.split("-")[0] || "en", // početni jezik
  fallbackLng: "de",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
